import dom from "../../../dist/jsx-render/dom"
import { MsoTable } from "./MsoTable";
import { ListItem } from "../../Model/ListItem";
import { app } from "../../Frame/App";

export class MsoTableInlineEdit {

    private dataSources: { [id: string]: Array<ListItem> };

    constructor(private table: MsoTable) {
        this.dataSources = {};
    }

    public getDataSource(modelId: string, field: string): JQueryPromise<Array<ListItem>> {
        return $.Deferred((deferrer) => {
            if (this.dataSources[field]) {
                deferrer.resolve(this.dataSources[field]);
            }
            else {
                $.get(app.resolveUrl(`~/api/tableview/getInlineDataSource/${modelId}/${field.replace("#", "%23")}`), (items: Array<ListItem>) => {
                    this.dataSources[field] = items;
                    deferrer.resolve(this.dataSources[field]);
                }).fail((response) => {
                    deferrer.reject(response);
                });
            }
        }).promise();
    }

    public saveValue(modelId: string, field: string, value: string): JQueryPromise<any> {
        return $.Deferred((deferrer) => {
            $.post(app.resolveUrl("~/api/tableview/saveInlineValue"), { modelId: modelId, fieldId: field, value: value })
                .done(() => {
                    deferrer.resolve();
                })
                .fail((response) => {
                    deferrer.reject(response);
                });
        }).promise();
    }

    public createDropdown(cell: HTMLElement, rowModel: any, idField: string, fieldId: string) {
        // add dropdown toggle
        let menuId = app.createGuid();
        let span = cell.firstElementChild;
        let toggle: HTMLElement = <a id={`${menuId}_toggle`} className="d-flex flex-grow-1 align-items-center" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>;
        cell.insertBefore(toggle, span);
        toggle.appendChild(span);

        // create empty menu with loading panel
        let menu = (
            <div id={menuId} className="dropdown-menu">
                <div className="text-center fa-2x">
                    <i className="fas fa-circle-notch fa-spin"></i>
                </div>
            </div>
        );
        cell.appendChild(menu);

        cell.setAttribute("data-dropdown-menu-id", menuId);
        cell.setAttribute("data-dropdown-item-id", rowModel[idField]);
        cell.setAttribute("data-dropdown-field-id", fieldId);

        // droppdown events
        $(cell).on("show.bs.dropdown", this.onShowDropdown);
        $(cell).on("hidden.bs.dropdown", this.onHiddenDropdown);

        // create dropdown
        $(toggle).dropdown();
    }

    onShowDropdown = (ev: Event) => {
        let cell = ev.currentTarget as HTMLElement;
        let modelId = cell.getAttribute("data-dropdown-item-id");
        let fieldId = cell.getAttribute("data-dropdown-field-id");
        let menuId = cell.getAttribute("data-dropdown-menu-id");
        let menu = document.getElementById(menuId);

        // move menu to body to prevent truncation of menu
        //document.body.appendChild(menu);

        this.getDataSource(modelId, fieldId).done((items: Array<ListItem>) => {
            menu.innerHTML = "";
            menu.appendChild(this.createDropDownItem(modelId, "0", "", fieldId, menuId, cell));
            for (let item of items) {
                menu.appendChild(this.createDropDownItem(modelId, item.id, item.name, fieldId, menuId, cell));
            }
        });
    }

    onHiddenDropdown = (ev: Event) => {
        // move menu back to original control
        let cell = ev.currentTarget as HTMLElement;
        let menu = document.getElementById(cell.getAttribute("data-dropdown-menu-id"));
        //cell.appendChild(menu);
    }

    private createDropDownItem(modelId: string, id: string, name: string, fieldId: string, menuId: string, cell: HTMLElement): HTMLElement {
        let div: HTMLElement = <a className="dropdown-item" href="#">Action</a>;
        div.innerText = name;

        div.addEventListener("click", () => {
            app.showWaitPanel();
            $(`#${menuId}_toggle`).dropdown("hide");
            this.saveValue(modelId, fieldId, id).done(() => {
                app.hideWaitPanel();
                cell.classList.add("mt-in-update");
                this.table.updateRow(modelId, () => {
                    cell.classList.remove("mt-in-update");
                });
            }).fail(() => {
                app.hideWaitPanel();
            });
        });

        return div;
    }
}